export default __webpack_public_path__ + "static/media/beta.5355494a.png";